
define('text!src/plugins/summaryWidget/res/ruleImageTemplate.html',[],function () { return '<div class="holder widget-rules-wrapper">\n    <div class="t-drag-rule-image l-widget-rule s-widget-rule"></div>\n</div>\n';});

